import { render } from "./BaseSelectLink.vue?vue&type=template&id=173b6e8a&ts=true"
import script from "./BaseSelectLink.vue?vue&type=script&lang=ts"
export * from "./BaseSelectLink.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__